/* RESPONSIBLE TEAM: team-standalone */

import { type ExampleCodeSnippetData } from './definitions';

export const GenericExampleCodeSnippetData: ExampleCodeSnippetData = {
  userIdInstallationInstructionKey:
    'apps.app.settings.installation.installation.new.instructions.example-code.user-id-comment',
};

export const ZendeskExampleCodeSnippetData: ExampleCodeSnippetData = {
  userIdInstallationInstructionKey:
    'apps.app.settings.installation.installation.new.instructions.example-code.user-id-zendesk-comment',
};

export const SalesforceExampleCodeSnippetData: ExampleCodeSnippetData = {
  userIdInstallationInstructionKey:
    'apps.app.settings.installation.installation.new.instructions.example-code.user-id-salesforce-comment',
};
